import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EnumsOrderState, OrderService, SalesStoreReportDto, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-shop-sales-report',
  templateUrl: './shop-sales-report.component.html',
  styleUrls: ['./shop-sales-report.component.css']
})

export class ShopSalesReportComponent implements OnInit {

  shopSalesReportForm: FormGroup = this.fb.group({
    status: [9],
    payment:[2],
    isShipping: [2]
    //liquidacion: [0],
    
  })
  displayedColumns: string[] = ['id', 'client', 'phone', 'address', 'status','total', 'discount','payment','delivery'];

  allOrders: SalesStoreReportDto[] = [];

  storeResponse: StoreResponseDto = {} as StoreResponseDto;

  dateFrom: any;
  dateTo: any;

  statusOptions = [
    { value: 0, viewValue: 'Nueva' },
    { value: 1, viewValue: 'Aceptada' },
    { value: 2, viewValue: 'Rechazada' },
    //{ value: 3, viewValue: 'Asignada a cadete' },
    //{ value: 4, viewValue: 'Cancelada' },
    { value: 5, viewValue: 'Cadete confirmado' },
    { value: 6, viewValue: 'En Viaje' },
    { value: 7, viewValue: 'Finalizada' },
    //{ value: 8, viewValue: 'Devuelta' },
    { value: 9, viewValue: 'Todas' }
  ];

  paymentOptions=[
    {value: 0, viewValue: 'Efectivo'},
    {value: 1, viewValue: 'Tarjeta'},
    {value:2, viewValue: 'Todos'}
  ]
  isShippingOptions=[
    {value: true, viewValue: 'Envío a Domicilio'},
    {value: false,viewValue: 'Retiro en Local'},
    {value: 2, viewValue: 'Todas'}
  ]
  // liquidacionOptions = [
  //   { value: 0, viewValue: 'Todos' },
  //   { value: 1, viewValue: 'Pendiente' },
  //   { value: 2, viewValue: 'Liquidado' },
  // ];

  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.storeResponse = this.authService.currentUserStore();
  }

  // exportPDF() {
  //   const doc = new jsPDF()
  //   doc.setFontSize(18);
  //   doc.text('Reporte de Ventas', 11, 8);
  //   doc.setFontSize(11);
  //   doc.setTextColor(100);
  //   doc.save("sales.pdf");
  // }

  inpuDateFrom(event: any) {
    this.dateFrom = event.value;
  }

  inpuDateTo(event: any) {
    this.dateTo = event.value;
  }

  get totalRows(): number {
    return this.allOrders.length;
  }

  getTotal(): number {
    return this.allOrders.reduce((sum, current) => sum + Number(current.qtTotal), 0)
  }

  // getTotalComision(): number {
  //   return this.allOrders.reduce((sum, current) => sum + Number(current.qtDiscount), 0)
  // }

  // getTotalLiquidation(): number {
  //   let total = this.getTotal();
  //   let commission = this.getTotalComision();

  //   return total - commission;
  // }

  previewReport(form: any) {
    let dateTo = moment(this.dateTo).endOf('day');
    let status = form.status == 9 ? undefined : form.status;
    let payment = form.payment == 2 ? undefined : form.payment;
    let isShipping = form.isShipping == 2 ? undefined : form.isShipping;
    this.orderService.apiOrderStoreReportsGet(this.storeResponse.cdStore, this.dateFrom, dateTo.toDate(), status, form.liquidacion,payment,isShipping).subscribe(x => {
      this.allOrders = x;
    });
  }
}
